'use strict';
import React, { useCallback, useEffect } from 'react';
import { useExpectedMidiHints } from 'AudioRecognition';
import { useWakeLock } from 'Hooks/useWakeLock';
// import { Auth } from 'aws-amplify';
import useMediaQuery from '@mui/material/useMediaQuery';
import { NoteType } from '@museflow-ai/opensheetmusicdisplay';
import MusicXML from 'Models/MusicXML';
import { Box, Button, Typography } from '@mui/material';
import { CustomCircularProgress } from 'Components/StyledComponents';
import * as appActions from 'Actions/app';
import * as eventActions from 'Actions/events';
import * as lessonActions from 'Actions/lesson';
import Phrase from 'Models/Phrase';
import ITimeKeeper from 'Models/ITimeKeeper';
import { createTimeKeeper } from 'Models/createTimeKeeper';

import { TickNoteEvent } from 'Utils/CustomEvents';
import { IntervalTimer } from 'Utils/IntervalTimer';
import { divisionsPerMeasureToNoteTypeIn4Over4 } from 'Utils';
import { isTouchDevice } from 'Utils/UserAgent';

import './MainApp.css';
import { useSelector, useDispatch } from 'react-redux';
//import EventStream from 'Models/EventStream';
import {
  MainAppReducer,
  UserLevelData,
  LevelStatus,
  ERROR_RECOGNITION_MODE,
  MidiEventState,
} from 'Types';

import { TimingOffsetsConfig } from 'Models/EventStream';
import { useLocation } from 'react-router-dom';

import { useMidiContext } from 'Contexts/MidiContext';
import { useNavigate } from 'react-router-dom';
import Scheduler2 from 'Utils/Scheduler2';
import TimeSignature from 'Models/TimeSignature';
import axios from 'axios';
import { Add, Remove } from '@mui/icons-material';
import { MIN_NUM_PHRASES } from 'Utils/Constants';
import { usePrevious } from 'Utils';
import { LessonReducer } from 'Reducers/lessonReducer';
// const axios = new AxiosRetrier();
import logger from 'Utils/Logger';
import { AppDispatch } from 'Reducers';
import { useAuthWrapperContext } from 'Contexts/AuthWrapperContext';
import { getCurrentAuthToken } from 'Utils/Auth';
import {
  AdaptiveTempoState,
  PhaserToReactListeners,
  NotifyPhaser,
  ReactListenForPhaser,
  NotifyPhaserEvents,
  RemoveListener,
  type StartPlayingArgs,
  ReactToPhaserListeners,
} from 'Phaser/EventBus2';
import { EventStreamPhaser2 } from 'Phaser/GameObjects/CursorMobile';
import { OSMDEventStream } from 'Phaser/GameObjects/OSMDEventStream';
import { IRefPhaserGame, PhaserGame } from 'Phaser/PhaserGame';
import { debounce } from 'lodash';
import { useFeatureFlag, FeatureFlag, isFeatureEnabled } from 'Utils/FeatureFlags';
import {
  getScoreThemePalette,
  normalizeScoreTheme,
  readScoreThemePreference,
} from 'Utils/ScoreTheme';
import type { ScoreTheme } from 'Utils/ScoreTheme';
import type { ParallelModeConversion } from 'Utils/MusicXmlModeConversion';
import { ZoomInIcon } from 'lucide-react';
import { useTempoContext } from 'Contexts/TempoContext';
import SettingsPanel from 'Components/SettingsPanel';
import FeedbackToast from 'Components/FeedbackToast';
import Logger from 'Utils/Logger';

/*const test_data = {
  svg_url_1440: "https://phrases.dev.museflow.ai/PNO/unit/1/level/1/tier/1/2026-02-07T14:22:30.000Z/svg/PNO0845a33f3ea69258eaa7a86200bb9f23.musicxml_1_1440.svg",
  music_xml_url: "https://phrases.dev.museflow.ai/PNO/unit/1/level/1/tier/1/2026-02-07T14:22:30.000Z/musicxml/PNO0845a33f3ea69258eaa7a86200bb9f23.musicxml",
  json_data_url_1440: "https://phrases.dev.museflow.ai/PNO/unit/1/level/1/tier/1/2026-02-07T14:22:30.000Z/json/PNO0845a33f3ea69258eaa7a86200bb9f23.musicxml_1_1440.cursor_data.json",
}*/

const _test_response: Record<string, unknown> = {
  data: {
    id: 69881,
    s3_batch_datetimestamp: '2026-02-07T14:22:30.000Z',
    tagging_version: '0.2.0',
    s3_music_xml_url:
      'https://phrases.dev.museflow.ai/PNO/unit/1/level/1/tier/1/2026-02-07T14:22:30.000Z/musicxml/PNO0845a33f3ea69258eaa7a86200bb9f23.musicxml',
    s3_music_xml_id: 'PNO0845a33f3ea69258eaa7a86200bb9f23',
    music_xml_url_pointers: {
      svg_url_800:
        'https://phrases.dev.museflow.ai/PNO/unit/1/level/1/tier/1/2026-02-07T14:22:30.000Z/svg/PNO0845a33f3ea69258eaa7a86200bb9f23.musicxml_1_800.svg',
      svg_url_960:
        'https://phrases.dev.museflow.ai/PNO/unit/1/level/1/tier/1/2026-02-07T14:22:30.000Z/svg/PNO0845a33f3ea69258eaa7a86200bb9f23.musicxml_1_960.svg',
      svg_url_1200:
        'https://phrases.dev.museflow.ai/PNO/unit/1/level/1/tier/1/2026-02-07T14:22:30.000Z/svg/PNO0845a33f3ea69258eaa7a86200bb9f23.musicxml_1_1200.svg',
      svg_url_1440:
        'https://phrases.dev.museflow.ai/PNO/unit/1/level/1/tier/1/2026-02-07T14:22:30.000Z/svg/PNO0845a33f3ea69258eaa7a86200bb9f23.musicxml_1_1440.svg',
      svg_url_1600:
        'https://phrases.dev.museflow.ai/PNO/unit/1/level/1/tier/1/2026-02-07T14:22:30.000Z/svg/PNO0845a33f3ea69258eaa7a86200bb9f23.musicxml_1_1600.svg',
      music_xml_url:
        'https://phrases.dev.museflow.ai/PNO/unit/1/level/1/tier/1/2026-02-07T14:22:30.000Z/musicxml/PNO0845a33f3ea69258eaa7a86200bb9f23.musicxml',
      json_data_url_800:
        'https://phrases.dev.museflow.ai/PNO/unit/1/level/1/tier/1/2026-02-07T14:22:30.000Z/json/PNO0845a33f3ea69258eaa7a86200bb9f23.musicxml_1_800.cursor_data.json',
      json_data_url_960:
        'https://phrases.dev.museflow.ai/PNO/unit/1/level/1/tier/1/2026-02-07T14:22:30.000Z/json/PNO0845a33f3ea69258eaa7a86200bb9f23.musicxml_1_960.cursor_data.json',
      json_data_url_1200:
        'https://phrases.dev.museflow.ai/PNO/unit/1/level/1/tier/1/2026-02-07T14:22:30.000Z/json/PNO0845a33f3ea69258eaa7a86200bb9f23.musicxml_1_1200.cursor_data.json',
      json_data_url_1440:
        'https://phrases.dev.museflow.ai/PNO/unit/1/level/1/tier/1/2026-02-07T14:22:30.000Z/json/PNO0845a33f3ea69258eaa7a86200bb9f23.musicxml_1_1440.cursor_data.json',
      json_data_url_1600:
        'https://phrases.dev.museflow.ai/PNO/unit/1/level/1/tier/1/2026-02-07T14:22:30.000Z/json/PNO0845a33f3ea69258eaa7a86200bb9f23.musicxml_1_1600.cursor_data.json',
      svg_url_timesig_800:
        'https://phrases.dev.museflow.ai/PNO/unit/1/level/1/tier/1/2026-02-07T14:22:30.000Z/svg/PNO0845a33f3ea69258eaa7a86200bb9f23.musicxml_1_time_sig_800.svg',
      svg_url_timesig_960:
        'https://phrases.dev.museflow.ai/PNO/unit/1/level/1/tier/1/2026-02-07T14:22:30.000Z/svg/PNO0845a33f3ea69258eaa7a86200bb9f23.musicxml_1_time_sig_960.svg',
      svg_url_timesig_1200:
        'https://phrases.dev.museflow.ai/PNO/unit/1/level/1/tier/1/2026-02-07T14:22:30.000Z/svg/PNO0845a33f3ea69258eaa7a86200bb9f23.musicxml_1_time_sig_1200.svg',
      svg_url_timesig_1440:
        'https://phrases.dev.museflow.ai/PNO/unit/1/level/1/tier/1/2026-02-07T14:22:30.000Z/svg/PNO0845a33f3ea69258eaa7a86200bb9f23.musicxml_1_time_sig_1440.svg',
      svg_url_timesig_1600:
        'https://phrases.dev.museflow.ai/PNO/unit/1/level/1/tier/1/2026-02-07T14:22:30.000Z/svg/PNO0845a33f3ea69258eaa7a86200bb9f23.musicxml_1_time_sig_1600.svg',
      timesig_json_data_url_800:
        'https://phrases.dev.museflow.ai/PNO/unit/1/level/1/tier/1/2026-02-07T14:22:30.000Z/json/PNO0845a33f3ea69258eaa7a86200bb9f23.musicxml_1_time_sig_800.cursor_data.json',
      timesig_json_data_url_960:
        'https://phrases.dev.museflow.ai/PNO/unit/1/level/1/tier/1/2026-02-07T14:22:30.000Z/json/PNO0845a33f3ea69258eaa7a86200bb9f23.musicxml_1_time_sig_960.cursor_data.json',
      timesig_json_data_url_1200:
        'https://phrases.dev.museflow.ai/PNO/unit/1/level/1/tier/1/2026-02-07T14:22:30.000Z/json/PNO0845a33f3ea69258eaa7a86200bb9f23.musicxml_1_time_sig_1200.cursor_data.json',
      timesig_json_data_url_1440:
        'https://phrases.dev.museflow.ai/PNO/unit/1/level/1/tier/1/2026-02-07T14:22:30.000Z/json/PNO0845a33f3ea69258eaa7a86200bb9f23.musicxml_1_time_sig_1440.cursor_data.json',
      timesig_json_data_url_1600:
        'https://phrases.dev.museflow.ai/PNO/unit/1/level/1/tier/1/2026-02-07T14:22:30.000Z/json/PNO0845a33f3ea69258eaa7a86200bb9f23.musicxml_1_time_sig_1600.cursor_data.json',
    },
    tier_number: 1,
    time_signature_numerator: 4,
    time_signature_denominator: 4,
    order_number: 0,
    num_measures: 4,
    num_notes: 10,
    approval_status: 'pending_review',
    createdAt: '2026-02-07T14:25:30.765Z',
    updatedAt: '2026-02-07T14:31:17.852Z',
    deletedAt: null,
    third_order_characteristics: {
      id: 33024,
      first_note_treble_pitches: [60],
      last_note_treble_pitches: [60],
      first_note_base_pitches: [],
      last_note_base_pitches: [],
      createdAt: '2026-02-07T14:25:30.765Z',
      updatedAt: '2026-02-07T14:31:17.852Z',
      deletedAt: null,
      __entity: 'ThirdOrderCharacteristics',
    },
    __entity: 'Phrase',
  },
};

// When false, fetchPhrase re-queries the backend if it returns a phrase already
// shown this session (repeat-avoidance, formerly handled by musicXMLStream).
const allowRepeatPhrases = false;
//const allowRepeatPhrases = true;

const minTempoForChevronFlash = 72;

// const createWorker = createWorkerFactory(() => import('WebWorkers/Scheduler'));

async function useComponentWillUnmount(cleanupCallback = () => {}) {
  // eslint-disable-next-line react-hooks/rules-of-hooks -- called in async helper, requires refactor to fix
  const callbackRef = React.useRef(cleanupCallback);
  callbackRef.current = cleanupCallback; // always up to date
  // eslint-disable-next-line react-hooks/rules-of-hooks -- called in async helper, requires refactor to fix
  React.useEffect(() => {
    return () => {
      callbackRef.current();
    };
  }, []);
}

const CustomSlider = ({
  value,
  onChange,
  min,
  max,
  step,
}: {
  value: number;
  onChange: (value: number) => void;
  min: number;
  max: number;
  step: number;
}) => {
  return (
    <input
      className="custom-slider"
      type="range"
      value={value}
      onChange={(e) => onChange(e.target.valueAsNumber)}
      min={min}
      max={max}
      step={step}
    />
  );
};

const ZoomSlider = ({
  zoomLevel,
  setZoomLevel,
}: {
  zoomLevel: number;
  setZoomLevel: (zoomLevel: number) => void;
}) => {
  const [minZoomLevel, maxZoomLevel] = [0.5, 1];
  const [isOpen, setIsOpen] = React.useState(true);
  const [collapseTimeoutHandle, setCollapseTimeoutHandle] = React.useState<
    NodeJS.Timeout | undefined
  >(undefined);

  React.useEffect(() => {
    if (collapseTimeoutHandle !== undefined) {
      clearTimeout(collapseTimeoutHandle);
    }
    if (isOpen) {
      setCollapseTimeoutHandle(
        setTimeout(() => {
          setIsOpen(false);
        }, 2000),
      );
    }
  }, [isOpen, zoomLevel]);

  return (
    <Box
      className={`zoom-slider-container ${isOpen ? 'open' : 'closed'}`}
      sx={{
        position: 'absolute',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        top: 10,
        right: 10,
        width: '200px',
        height: '34px',
        padding: '5px',
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        backdropFilter: 'blur(5px)',
        zIndex: 1,
        cursor: 'pointer',
      }}
    >
      <Box
        /*className={isOpen ? "inner-container vis" : "inner-container hid"}*/
        sx={{
          flexGrow: 1,
          transition: '0.5s ease-in-out',
          marginRight: '35px',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Remove
          sx={{ color: '#414753' }}
          onClick={() => setZoomLevel(Math.max(minZoomLevel, zoomLevel - 0.05))}
        />
        <CustomSlider
          min={minZoomLevel}
          step={0.05}
          max={maxZoomLevel}
          value={Math.max(minZoomLevel, Math.min(maxZoomLevel, zoomLevel))}
          onChange={(value) => setZoomLevel(value)}
        />
        <Add
          sx={{ color: '#414753' }}
          onClick={() => setZoomLevel(Math.min(maxZoomLevel, zoomLevel + 0.05))}
        />
      </Box>
      <ZoomInIcon
        onClick={() => setIsOpen((open) => !open)}
        style={{
          color: '#414753',
          opacity: isOpen ? 1 : 0.5,
          position: 'absolute',
          right: 10,
          width: 20,
          height: 20,
          cursor: 'pointer',
        }}
      />
      {process.env.REACT_APP_NODE_ENV != 'prd' && (
        <p
          style={{
            color: '#000',
            opacity: 0.5,
            position: 'absolute',
            right: 10,
            top: 30,
            fontSize: 12,
          }}
        >
          [debug] Zoom Level: {(zoomLevel ?? 0.9).toFixed(2)}
        </p>
      )}
    </Box>
  );
};

interface MainAppProps {
  showKeyboard: boolean;
  setAccuracy: (x: number) => void;
  setShowAccuracy: (x: boolean) => void;
  setAllowChevrons: (x: boolean) => void;
  cursorIsVisible: boolean;
  setCursorIsVisible: (visible: boolean) => void;
  setCurrentTier: (x: number) => void;
  currentTier: number;
  updateCurrentTier: (x: number) => void;
  showTierComplete: boolean;
  freePlay: boolean;
  mobile: boolean;
  playButtonOverlap?: number;
  settingsShown: boolean;
  onCloseSettings?: () => void;
  setShowDebugTierSummary: (x: boolean) => void;
  showDebugTierSummary: boolean;
  setShowDebugRepertoireUnlocked: (x: boolean) => void;
  showDebugRepertoireUnlocked: boolean;
  showSightReadingTransposeControls?: boolean;
  sightReadingTransposeSemitones?: number;
  onSightReadingTransposeChange?: (nextSemitones: number) => void;
  sightReadingModeConversion?: ParallelModeConversion;
  onSightReadingModeConversionChange?: (nextMode: ParallelModeConversion) => void;
  // musicXmlSvgWidth: number
}
// function MainApp(props: MainAppProps) {
function MainAppPhaser(props: MainAppProps) {
  const {
    setShowDebugTierSummary,
    showDebugTierSummary,
    setShowDebugRepertoireUnlocked,
    showDebugRepertoireUnlocked,
  } = props;
  const _navigate = useNavigate();
  const _location = useLocation();

  const data = useSelector((state: MainAppReducer) => state.mainAppReducer);
  const lesson = useSelector((state: LessonReducer) => state.lessonReducer);

  const dispatch = useDispatch<AppDispatch>();
  useWakeLock();

  const {
    setAccuracy,
    setAllowChevrons,
    currentTier,
    updateCurrentTier: _updateCurrentTier,
    setCurrentTier: _setCurrentTier,
    setShowAccuracy,
    showTierComplete,
    cursorIsVisible,
    setCursorIsVisible,
    freePlay,
    //mobile,
    playButtonOverlap = 0,
    settingsShown,
    onCloseSettings,
    showSightReadingTransposeControls,
    sightReadingTransposeSemitones = 0,
    onSightReadingTransposeChange,
    sightReadingModeConversion = 'off',
    onSightReadingModeConversionChange,
  } = props;

  const mobile =
    useMediaQuery('(max-width:960px)') && isFeatureEnabled(FeatureFlag.USE_MOBILE_SIGHT_READING);
  const sightReadingTransposeFlagEnabled = useFeatureFlag(
    FeatureFlag.USE_TRANSPOSE_SIGHT_READING_TRAINER,
  );
  const transposeModeConversionEnabled = useFeatureFlag(FeatureFlag.USE_TRANSPOSE_MODE_CONVERSION);
  const lessonZoomEnabled = useFeatureFlag(FeatureFlag.USE_LESSON_ZOOM);
  const transposeSightReadingTrainerEnabled =
    showSightReadingTransposeControls ?? sightReadingTransposeFlagEnabled;
  const effectiveSightReadingTransposeSemitones = transposeSightReadingTrainerEnabled
    ? sightReadingTransposeSemitones
    : 0;
  const effectiveSightReadingModeConversion: ParallelModeConversion =
    transposeSightReadingTrainerEnabled && transposeModeConversionEnabled
      ? sightReadingModeConversion
      : 'off';
  const sightReadingTransformResetPendingRef = React.useRef(false);
  const [sightReadingPhraseDispatchVersion, setSightReadingPhraseDispatchVersion] =
    React.useState(0);

  const mobileRef = React.useRef(mobile);
  mobileRef.current = mobile;

  const { currentUserLevelData, phrasesTilNextTier, lessonPlaying, currentLevelTiers } = lesson;

  // Ref mirrors lessonPlaying so the spacebar handler always reads the
  // current value without needing to re-register on every change.
  const lessonPlayingRef = React.useRef(lessonPlaying);
  lessonPlayingRef.current = lessonPlaying;

  // Same for phrasesTilNextTier
  const phrasesTilNextTierRef = React.useRef(phrasesTilNextTier);
  phrasesTilNextTierRef.current = phrasesTilNextTier;

  // const { timeKeeper, midiStream } = props.midiProps
  const { levelSelect, unitSelect } = data;
  const {
    tempo,
    goalTempo,
    startAdaptiveSegment,
    endAdaptiveSegment,
    changeTempo,
    ataEnabled,
    freePlayMode,
    usingCustomGoalTempo,
    restoreSavedTempo,
  } = useTempoContext();

  const startAdaptiveSegmentRef = React.useRef(startAdaptiveSegment);
  const endAdaptiveSegmentRef = React.useRef(endAdaptiveSegment);
  const changeTempoRef = React.useRef(changeTempo);
  startAdaptiveSegmentRef.current = startAdaptiveSegment;
  endAdaptiveSegmentRef.current = endAdaptiveSegment;
  changeTempoRef.current = changeTempo;

  const [tempoToast, setTempoToast] = React.useState<
    [string, boolean] /* [text, goalTempoHit] */ | undefined
  >(undefined);
  const [tempoToastVisible, setTempoToastVisible] = React.useState(false);

  logger.debug('LEVEL SELECT', levelSelect, 'UNIT SELECT', unitSelect);

  const previousTier = usePrevious(currentUserLevelData?.current_tier);
  const [localPlaySessionId, setLocalPlaySessionId] = React.useState<string | undefined | null>(
    undefined,
  );

  // FIXME: Tempo should be grabbed from redux only - not set as its own state. Or removed from redux.
  // const [tempo, setTempo] = React.useState(data.tempo)
  const [_initialized, setInitialized] = React.useState(false);
  // const [ musicXmlSvgWidth, setMusicXmlSvgWidth] = React.useState(960)
  const musicXmlSvgWidth = React.useRef(960);
  const min960 = useMediaQuery('(min-width:960px)');
  const min1100 = useMediaQuery('(min-width:1100px)');
  const min1300 = useMediaQuery('(min-width:1300px)');
  const min1650 = useMediaQuery('(min-width:1650px)');
  const min1850 = useMediaQuery('(min-width:1850px)');

  const { userData } = data;
  // Seed from the synchronous localStorage preference so the very first paint
  // already uses the right theme; `userData` arrives async, and without this the
  // theme falls back to 'light' (white) until it loads — a flash of white.
  const scoreTheme = normalizeScoreTheme(
    userData?.practice_score_theme ?? readScoreThemePreference(),
    userData?.practice_dark_mode,
  );
  const scorePalette = getScoreThemePalette(scoreTheme);

  const [dimens, setDimens] = React.useState<{ x: number; y: number } | undefined>(undefined);

  React.useEffect(() => {
    if (min1850) {
      musicXmlSvgWidth.current = 1600;
    } else if (min1650) {
      musicXmlSvgWidth.current = 1440;
    } else if (min1300) {
      musicXmlSvgWidth.current = 960;
    } else if (min1100) {
      musicXmlSvgWidth.current = 800;
    } else if (min960) {
      // this might not work - need to add additional choices in the parsing lambda. I don't think we support this anyway
      musicXmlSvgWidth.current = 800;
    }
  }, [min960, min1100, min1300, min1650, min1850]);

  React.useEffect(() => {
    NotifyPhaserEvents.SetAtaEnabled({ enabled: ataEnabled });
  }, [ataEnabled]);

  // const { user } = useAuth();
  const { authInitialized, currentAuthToken } = useAuthWrapperContext();

  // const [showKeyboard ] = React.useState(props.showKeyboard == false ? false : true);
  // const [showNextPhraseButton ] = React.useState(props.showKeyboard == false ? false : true);
  // const [showStartStopButtons] = React.useState(props.showKeyboard == false ? false : true);
  const [musicLoaded, setMusicLoaded] = React.useState(false);
  // show music works with music loaded. The music loads on screen one staff line at a time, which doesn't look as clean.
  // when loaded, instead of just loading the div, we load the div hidden, which allows the svgs to render, then unhide.
  const [showMusic, setShowMusic] = React.useState(false);
  const [_started, _setStarted] = React.useState(false);
  const startedRef = React.useRef(false);
  const tempoRef = React.useRef(tempo);
  tempoRef.current = tempo;
  const setStarted = React.useCallback((val: boolean) => {
    startedRef.current = val;
    _setStarted(val);
  }, []);
  const [tickNoteType] = React.useState(NoteType._64th);
  // const [isEligible, setIsEligible] = React.useState(true); // Whether user is eligable for a chevron
  // const [currentPhraseIsEligable, setCurrentPhraseIsEligible] = React.useState(true);
  // the initial purpose of this was to have a way to update lower components at will, but it's not used.
  const [_updateKey, _setUpdateKey] = React.useState(0);

  const [zoomLevel, setZoomLevel] = React.useState(data.zoomLevel ?? 0.9);

  React.useEffect(() => {
    const zoom = Math.max(0.5, Math.min(zoomLevel, 1));
    NotifyPhaserEvents.SetZoomLevel({ zoomLevel: zoom });
    dispatch(appActions.setZoomLevel(zoom));
  }, [zoomLevel, dispatch]);

  const accumulatedTimeRef = React.useRef(0);
  const lastMeasuredTimeRef = React.useRef(0);

  const keyCallbackRef = React.useRef<((ev: KeyboardEvent) => void) | null>(null);

  const _firstPhraseRef = React.useRef(true);
  // Last measure that the user fully played.
  const lastPlayedMeasureRef = React.useRef(-1);
  // Phrase hashes already served this session, for repeat-avoidance. The
  // PhraseManager pulls phrases on demand, so we re-query if the backend hands
  // back a phrase we've recently shown.
  const servedPhraseHashesRef = React.useRef<Set<string>>(new Set());
  // Whether the UI time signature has been pushed from the first fetched phrase.
  const timeSigDispatchedRef = React.useRef(false);
  // This interval timer isn't related to the in-game audiocontext timer.
  // it doesn't have to be as precise. Also, the scheduler only schedules in ticks.
  const recordPlayTimeInterval = React.useCallback(() => {
    if (data.levelSelect !== undefined && currentUserLevelData?.current_tier !== undefined) {
      const now = new Date().getTime();
      accumulatedTimeRef.current = now - lastMeasuredTimeRef.current + accumulatedTimeRef.current;
      lastMeasuredTimeRef.current = now;
    }
  }, [data.levelSelect, currentUserLevelData?.current_tier]);

  // by breaking up the recording of play time and the sending of play time we can be more accurate
  // with the recording without ddosing the backend.
  const sendPlayTimeInterval = React.useCallback(() => {
    if (
      data.levelSelect !== undefined &&
      currentUserLevelData?.current_tier !== undefined &&
      currentUserLevelData?.play_session?.id
    ) {
      dispatch(
        eventActions.levelPlayingEventAction(
          accumulatedTimeRef.current,
          data.levelData[levelSelect].level_number,
          currentUserLevelData?.play_session?.id,
        ),
      );
    }
  }, [
    data.levelSelect,
    data.levelData,
    currentUserLevelData?.current_tier,
    currentUserLevelData?.play_session?.id,
    dispatch,
    levelSelect,
  ]);

  const recordPlayTimeIntervalTimer = React.useRef<IntervalTimer | undefined>(undefined);
  const sendPlayTimeIntervalTimer = React.useRef<IntervalTimer | undefined>(undefined);
  const lastPlayedNoteTimer = React.useRef<NodeJS.Timeout | undefined>(undefined);

  const [timeKeeper, _setTimeKeeper] = React.useState(createTimeKeeper());
  const [midiStream, setMidiStream] = React.useState(
    new EventStreamPhaser2(
      timeKeeper,
      new TimingOffsetsConfig(),
      data.userData?.colorblind_type || null,
    ),
  );
  interface MidiNoteEvent {
    note: number;
    velocity: number;
  }

  const noteOff = React.useCallback(
    (ev: MidiNoteEvent) => {
      midiStream.handleNoteOffEvent(ev.note);
      NotifyPhaserEvents.MidiOff({ note: ev.note });
    },
    [midiStream],
  );

  const noteOn = React.useCallback(
    (ev: MidiNoteEvent) => {
      if (ev.velocity !== 0) {
        setShowAccuracy(true);
        clearTimeout(lastPlayedNoteTimer?.current);
        if (process.env.REACT_APP_CURSOR_TIMEOUT) {
          lastPlayedNoteTimer.current = setInterval(() => {
            dispatch(lessonActions.setLessonPlaying({ lessonPlaying: false }));
          }, 10000);
        }
        midiStream.handleNoteOnEvent(ev.note, ev.velocity);
        NotifyPhaserEvents.MidiOn({ note: ev.note, velocity: ev.velocity });
      } else {
        noteOff(ev); // call the note off logic becasue velocity is 0.
      }
    },
    [midiStream, noteOff, dispatch, setShowAccuracy],
  );

  const listener = React.useRef({
    name: 'eventListener',
    noteOn,
    noteOff,
  });
  const { addListener, removeListener, clearListeners, preferredInputMode } = useMidiContext();

  const [scheduler2, setScheduler2] = React.useState(new Scheduler2(timeKeeper));
  // Monotonically increasing counter, bumped on every reset(). Captured by
  // onStart's closure so stale invocations (from a pre-reset StartedPlaying
  // event) can detect they are outdated and bail out before registering
  // interval functions on a destroyed scheduler.
  const schedulerGenerationRef = React.useRef(0);

  useEffect(() => {
    scheduler2.updateWorkerState({ freePlay });
    NotifyPhaserEvents.SetFreePlayMode({ enabled: freePlay });
  }, [freePlay, scheduler2]);

  useEffect(() => {
    NotifyPhaserEvents.SetCursorVisible({ visible: cursorIsVisible });
  }, [cursorIsVisible]);

  const [feedbackToastText, setFeedbackToastText] = React.useState<string | null>(null);
  const feedbackToastInvalidationTimerRef = React.useRef<NodeJS.Timeout | null>(null);
  const tempoToastInvalidationTimerRef = React.useRef<NodeJS.Timeout | null>(null);
  const tempoToastTypeRef = React.useRef<'ata-change' | 'min-max-tempo' | undefined>(undefined);

  useExpectedMidiHints({
    enabled: preferredInputMode === 'audio',
    getExpectedMidiNotes: () => midiStream.getExpectedMidiNotes(),
  });

  const showFeedbackToast = React.useCallback(
    ({ state }: { state: MidiEventState }) => {
      let text = '';
      switch (state) {
        case MidiEventState.LATE_ONSET:
          text = 'Too late';
          break;
        case MidiEventState.EARLY_ONSET:
          text = 'Too early';
          break;
        case MidiEventState.WRONG_NOTE:
          text = 'Wrong note!';
          break;
        case MidiEventState.LATE_OFFSET:
          text = 'Too long!';
          break;
        case MidiEventState.EARLY_OFFSET:
          text = 'Too short!';
          break;
        default:
          logger.warn('Unknown state for feedback toast:', state);
      }
      logger.debug('Showing feedback toast:', text);
      if (!text) return;
      setFeedbackToastText(text);
      if (feedbackToastInvalidationTimerRef.current) {
        clearTimeout(feedbackToastInvalidationTimerRef.current);
      }
      feedbackToastInvalidationTimerRef.current = setTimeout(() => {
        setFeedbackToastText(null);
        feedbackToastInvalidationTimerRef.current = null;
      }, 1000);
    },
    [setFeedbackToastText],
  );

  React.useEffect(() => {
    if (feedbackToastText) {
      if (feedbackToastInvalidationTimerRef.current) {
        clearTimeout(feedbackToastInvalidationTimerRef.current);
      }
      feedbackToastInvalidationTimerRef.current = setTimeout(() => {
        setFeedbackToastText(null);
        feedbackToastInvalidationTimerRef.current = null;
      }, 1000);
    }
  }, [feedbackToastText]);

  React.useEffect(() => {
    const showToast = (message: string) => {
      setFeedbackToastText(message);
    };
    Logger.debug('Setting up feedback listener');
    PhaserToReactListeners.ShowFeedbackToast(showFeedbackToast);
    PhaserToReactListeners.ShowToast(showToast);
    return () => {
      RemoveListener('ShowFeedbackToast');
      RemoveListener('ShowToast');
    };
  }, [showFeedbackToast]);

  /*useEffect(() => {
    setTempoToastVisible(false);
  }, [currentTier]);*/

  useEffect(() => {
    const listener = (tempoState: AdaptiveTempoState) => {
      const { state, value } = tempoState;
      Logger.debug('setting adaptive tempo state', tempoState);
      switch (state) {
        case 'started':
          startAdaptiveSegmentRef.current(value);
          break;
        case 'completed':
          endAdaptiveSegmentRef.current(value);
          setTempoToastVisible(false);
          break;
        case 'progress':
          changeTempoRef.current({ value, goal: false, fromAta: true });
          break;
      }
    };
    const regionCreated = (regionType: 'speed-up' | 'slow-down') => {
      Logger.debug('[AtaMessage] regionCreated', regionType);
      setTempoToast([
        regionType === 'speed-up' ? "Great job! Let's speed it up!" : "Let's slow down a bit.",
        false,
      ]);
      setTempoToastVisible(true);
      tempoToastTypeRef.current = 'ata-change';
    };
    const hasMasteredGoalTempo = ({
      performance,
      customGoal,
    }: {
      performance: 'good' | 'poor';
      customGoal?: boolean;
    }) => {
      const text =
        performance === 'good'
          ? customGoal
            ? "You've hit your goal tempo! Well done!"
            : "You've hit the max tempo! Well done!"
          : "You've hit the lowest tempo.";
      setTempoToast([text, true]);
      setTempoToastVisible(true);
      tempoToastTypeRef.current = 'min-max-tempo';
      /*tempoToastInvalidationTimerRef.current = setTimeout(() => {
        setTempoToast(undefined);
        tempoToastInvalidationTimerRef.current = null;
      }, 1000);*/
      if (tempoToastInvalidationTimerRef.current) {
        clearTimeout(tempoToastInvalidationTimerRef.current);
      }
      tempoToastInvalidationTimerRef.current = null;
    };
    const abortListener = () => {
      setTempoToastVisible(false);
    };
    //ListenForPhaserEvent(ListenSetAdaptiveTempoState(listener));
    // We can listen for abort events in react (even the ones that are sent 'to phaser') because they're just events.
    ReactToPhaserListeners.AbortAdaptiveTempo(abortListener);
    PhaserToReactListeners.SetAdaptiveTempoState(listener);
    PhaserToReactListeners.AdaptiveTempoRegionCreated(regionCreated);
    PhaserToReactListeners.SuggestLevelChange(hasMasteredGoalTempo);
    return () => {
      console.debug('[AtaMessage] removing adaptive tempo listeners');
      RemoveListener('SetAdaptiveTempoState');
      RemoveListener('AdaptiveTempoRegionCreated');
      RemoveListener('AbortAdaptiveTempo');
      RemoveListener('SuggestLevelChange');
    };
  }, []);

  React.useEffect(() => {
    if (!tempoToastVisible) {
      tempoToastInvalidationTimerRef.current = setTimeout(() => {
        setTempoToast(undefined);
        tempoToastInvalidationTimerRef.current = null;
      }, 1000);
    }
    return () => {
      if (tempoToastInvalidationTimerRef.current) {
        clearTimeout(tempoToastInvalidationTimerRef.current);
      }
      tempoToastInvalidationTimerRef.current = null;
    };
  }, [tempoToastVisible]);

  React.useEffect(() => {
    //setTempoToastVisible(false);
    setTempoToast(undefined);
  }, [currentTier, ataEnabled]);

  useEffect(() => {
    if (tempoToastTypeRef.current === 'min-max-tempo') {
      setTempoToast(undefined);
      tempoToastTypeRef.current = undefined;
      if (tempoToastInvalidationTimerRef.current) {
        clearTimeout(tempoToastInvalidationTimerRef.current);
      }
      tempoToastInvalidationTimerRef.current = null;
    }
  }, [freePlay]);

  React.useEffect(() => {
    scheduler2?.updateWorkerState({ phrasesTilNextTier: phrasesTilNextTier });
  }, [phrasesTilNextTier, scheduler2]);

  const _x = React.useCallback(() => {}, []);

  const getPhraseInfo = React.useCallback(
    async (tier: number, firstCall: boolean = false) => {
      const levelNumber = data.levelData[levelSelect].level_number;
      // instead of using the auth context, I'm using amplify auth. It seems like the currying done
      // in the timekeeper function is leading to the token rotation not working as expected.
      // Theoretically this should work even if that doesn't. But it's possible it will have the same issue.
      // const user = await Auth.currentAuthenticatedUser();

      const _token = await currentAuthToken();
      const options = {
        url:
          process.env.REACT_APP_BACKEND_URL +
          `/api/v1/phrases/gen-phrase?levelNumber=${levelNumber}&tierNumber=${tier}&excludeFirstNoteRest=${firstCall}`,
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${await currentAuthToken()}`,
        },
      };
      //firstPhraseRef.current = false;
      const response = await axios.request(options);
      //const response = test_response;
      return {
        uuid: response['data']['s3_music_xml_id'],
        s3_music_xml_url: response['data']['s3_music_xml_url'],
        svg_url: response['data']['music_xml_url_pointers'][`svg_url_${musicXmlSvgWidth.current}`],
        svg_url_timesig:
          response['data']['music_xml_url_pointers'][`svg_url_timesig_${musicXmlSvgWidth.current}`],
        json_data_url:
          response['data']['music_xml_url_pointers'][`json_data_url_${musicXmlSvgWidth.current}`],
        json_data_url_timesig:
          response['data']['music_xml_url_pointers'][
            `timesig_json_data_url_${musicXmlSvgWidth.current}`
          ],
        time_signature_numerator: response['data']['time_signature_numerator'],
        time_signature_denominator: response['data']['time_signature_denominator'],
        num_notes: response['data']['num_notes'],
      };
    },
    [data.levelData, currentAuthToken, musicXmlSvgWidth, levelSelect],
  );

  const fetchOnePhrase = React.useCallback(
    async (tier: number, excludeFirstNoteRest: boolean): Promise<Phrase> => {
      console.debug('Fetching phrase, ', { excludeFirstNoteRest });
      const phraseData = await getPhraseInfo(tier, excludeFirstNoteRest);
      const [musicXmlRes, cursorDataRes, cursorDataTimesigRes] = await Promise.all([
        axios.get(phraseData.s3_music_xml_url),
        axios.get(phraseData.json_data_url),
        axios.get(phraseData.json_data_url_timesig),
      ]);
      logger.info('phrase retrieved', cursorDataRes.data, 'request', { excludeFirstNoteRest });
      const musicXML = new MusicXML(musicXmlRes.data, [
        new TimeSignature(
          phraseData.time_signature_numerator,
          phraseData.time_signature_denominator,
        ),
      ]);
      return new Phrase(
        phraseData.uuid,
        musicXML,
        phraseData.num_notes,
        phraseData.svg_url,
        phraseData.svg_url_timesig,
        cursorDataRes.data.serializedIterator,
        cursorDataTimesigRes.data.serializedIterator,
        cursorDataRes.data.measureRects,
      );
    },
    [getPhraseInfo],
  );

  // Answers the PhraseManager's FetchPhrase requests: fetch one phrase, avoid
  // recently-seen repeats, and hand it to Phaser via PhraseReady.
  const fetchPhrase = React.useCallback(
    async ({
      excludeFirstNoteRest,
      sequenceId,
    }: {
      excludeFirstNoteRest: boolean;
      sequenceId: number;
    }) => {
      // Read the live tier from lessonReducer (currentUserLevelData), which is
      // updated on every tier advance (UPDATE_CURRENT_ULP_SUCCESS). The
      // mainAppReducer's currentUserLevelData is only a SET_LEVEL_SELECT
      // snapshot and never advances, which pinned every request to tier 1.
      const tier = currentUserLevelData?.current_tier || 1;
      console.debug(
        `[phrase-seq] REQUEST seq=${sequenceId} excludeFirstNoteRest=${excludeFirstNoteRest}`,
      );
      let phrase = await fetchOnePhrase(tier, excludeFirstNoteRest);
      // Repeat-avoidance: re-query if the backend hands back a phrase we've
      // already shown this session (formerly handled by musicXMLStream).
      if (!allowRepeatPhrases) {
        for (
          let attempts = 0;
          attempts < 5 && servedPhraseHashesRef.current.has(phrase.musicXML.hash);
          attempts++
        ) {
          logger.info('found repeat - requerying');
          phrase = await fetchOnePhrase(tier, excludeFirstNoteRest);
        }
      }
      servedPhraseHashesRef.current.add(phrase.musicXML.hash);

      // Push the UI time signature from the first phrase of the session.
      if (!timeSigDispatchedRef.current) {
        timeSigDispatchedRef.current = true;
        const timeSig = phrase.musicXML.timeSignatures[0];
        dispatch(lessonActions.setLessonTimeSigNumerator(timeSig?.numerator || 4));
        dispatch(lessonActions.setLessonTimeSigDenominator(timeSig?.denominator || 4));
      }

      // The PhraseManager owns transposition: it applies the current
      // transpose/mode to the raw phrase and rebuilds on SetSightReadingTranspose.
      NotifyPhaserEvents.PhraseReady({ phrase, sequenceId });
    },
    [fetchOnePhrase, currentUserLevelData, dispatch],
  );

  useEffect(() => {
    // EventBus.on adds a listener without de-duping. Without this cleanup,
    // each re-creation of fetchPhrase (driven by its `data`/`dispatch` deps)
    // stacks another listener — so a single Phaser FetchPhrase event fans out
    // to N handlers, each pushing its own PhraseReady to Phaser.
    PhaserToReactListeners.FetchPhrase(fetchPhrase);
    return () => RemoveListener('FetchPhrase', fetchPhrase);
  }, [fetchPhrase]);

  const getTiersForLevel = React.useCallback(
    async function getTiersForLevel() {
      const accessToken = await getCurrentAuthToken();
      const levelNumber = data.levelData[data.levelSelect].level_number;
      const options = {
        url:
          process.env.REACT_APP_BACKEND_URL +
          `/api/v1/phrases/tiers-by-level?levelNumber=${levelNumber}`,
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await axios.request(options);
      return response['data'];
    },
    [data.levelSelect, data.levelData],
  );

  const incrementPhrase = React.useCallback(function incrementPhrase(
    ev: CustomEvent<{
      ticks: number;
      timeKeeper: ITimeKeeper;
      workerState: Record<string, unknown>;
    }>,
  ) {
    const isCountingIn = ev.detail.timeKeeper.getIsCountingIn();
    const ticksPerMeasure = ev.detail.timeKeeper.getTicksPerMeasure();
    const computedMeasure = Math.floor(ev.detail.ticks / ticksPerMeasure) - 1;
    if (!isCountingIn) {
      // We want the last measure that was FULLY PLAYED, hence the floor and subtract 1.
      // We subtract 1 since if we just got to a new measure the LAST measure was fully played.
      // Also wrap the whole thing in Math.max(), since once we hit the first measure after the count in,
      // we'd actually move back a measure if we stopped playback during the first measure after count-in without it.
      // Next-phrase fetching is now request-driven by the PhraseManager; this
      // only keeps the last-played-measure marker used for cursor/resume logic.
      lastPlayedMeasureRef.current = Math.max(lastPlayedMeasureRef.current, computedMeasure);
    }
  }, []);

  const dispatchPhraseEvent = React.useCallback(
    function dispatchPhraseEvent(
      levelNumber: number,
      tierNumber: number,
      playSessionId: string,
      nBefore: number = 1,
      immediate: boolean = false,
    ) {
      const phrase = midiStream.getNBeforePhrase(nBefore);
      if (phrase && !phrase?.getComplete()) {
        phrase?.setComplete(true);

        const dispatchPhraseData = () => {
          if (phrase) {
            const phraseData = phrase.generatePhraseCompletedEventData();
            if (phraseData.midiData.length > 2) {
              dispatch(
                eventActions.phraseCompletedEventAction({
                  midiData: phraseData.midiData,
                  errorData: phraseData.errorData,
                  accuracy: phraseData.accuracy,
                  avgLHAccuracy: phraseData.lhAccuracy,
                  avgRHAccuracy: phraseData.rhAccuracy,
                  avgRunningAccuracy: phraseData.avgRunningAccuracy,
                  avgLHRunningAccuracy: phraseData.avgLHRunningAccuracy,
                  avgRHRunningAccuracy: phraseData.avgRHRunningAccuracy,
                  totalNotes: phraseData.totalNotes,
                  lhTotalNotes: phraseData.lhTotalNotes,
                  rhTotalNotes: phraseData.rhTotalNotes,
                  errorScore: phraseData.errorScore,
                  lhErrorScore: phraseData.lhErrorScore,
                  rhErrorScore: phraseData.rhErrorScore,
                  phraseS3Id: phrase?.uuid,
                  tierNumber,
                  levelNumber,
                  bpm: data.tempo,
                  playSessionId: playSessionId,
                }),
              );
            }
          }
        };

        if (immediate) {
          dispatchPhraseData();
        } else {
          setTimeout(dispatchPhraseData, 200);
        }
      }
    },
    [midiStream, dispatch, data.tempo],
  );

  const startMidiStreamUpdateLoop = React.useCallback(
    function startMidiStreamUpdateLoop() {
      scheduler2?.setIntervalByTick(
        'updateMidiStream',
        (ev: typeof TickNoteEvent) => {
          midiStream.update();
          if (currentUserLevelData?.play_session?.id) {
            dispatchPhraseEvent(
              ev.detail.workerState.levelNumber as number,
              ev.detail.workerState.tier as number,
              ev.detail.workerState.play_session_id as string,
            );
          }
        },
        NoteType._32nd,
        1,
      );
    },
    [midiStream, scheduler2, currentUserLevelData?.play_session?.id, dispatchPhraseEvent],
  );

  /*const startPhraseLoop = React.useCallback(
    function startPhraseLoop() {
      const denom = divisionsPerMeasureToNoteTypeIn4Over4(
        timeKeeper.getTimeSignature()?.denominator,
      );
      const numer = timeKeeper.getTimeSignature().numerator;
      // Per-measure tick that keeps lastPlayedMeasureRef current. Phrase fetching
      // is now request-driven by the PhraseManager (FetchPhrase -> fetchPhrase),
      // so this no longer pre-fetches phrases itself.
      scheduler2?.setIntervalByTick(
        'phraseLoop',
        function phraseLoop(ev: typeof TickNoteEvent) {
          incrementPhrase(ev);
        },
        denom,
        numer * 4,
        numer,
      );
    },
    [incrementPhrase, scheduler2, timeKeeper],
  );*/

  // This is now handled in phaser
  const startAccuracyLoop = React.useCallback(() => {
    // Keep accuracy display in React, but do **not** drive chevron
    // eligibility from here. Chevron eligibility and phrase-level
    // gain/loss are handled inside the Phaser OSMD scene.
    scheduler2?.setIntervalByTick(
      'accuracyLoop',
      function accuracyLoop(_ev: typeof TickNoteEvent) {
        const accuracy = midiStream.calcAccuracy();
        setAccuracy(accuracy);
        // Only show accuracy once the cursor has passed over actual notes (not during preroll)
        if (midiStream.hasRealNotesMarked()) {
          setShowAccuracy(true);
        }
      },
      divisionsPerMeasureToNoteTypeIn4Over4(timeKeeper.getTimeSignature()?.denominator),
      1,
      0,
    );
  }, [midiStream, scheduler2, setAccuracy, setShowAccuracy, timeKeeper]);

  useEffect(() => {
    scheduler2?.updateWorkerState({ tempo: tempo });
  }, [scheduler2, setAllowChevrons, tempo]);

  useEffect(() => {
    scheduler2?.updateWorkerState({
      play_session_id: currentUserLevelData?.play_session?.id,
    });
  }, [scheduler2, currentUserLevelData?.play_session?.id]);

  const startChevronLoop = React.useCallback(() => {
    // Chevron gain/loss and per-phrase eligibility are handled inside
    // the Phaser OSMD scene. We intentionally disable the legacy
    // scheduler-driven chevron loop here to avoid double-counting and
    // mid-phrase mutations.
    return;
  }, []);

  const onStop = React.useCallback(() => {
    restoreSavedTempo();
    //endAdaptiveSegment();
    NotifyPhaserEvents.PauseExercise();
    //Logger.debug('lastPlayedMeasureRef', lastPlayedMeasureRef.current);
    const _last = lastPlayedMeasureRef.current;
    //NotifyPhaser(SetCursor(lastPlayedMeasureRef.current + 1));
    recordPlayTimeIntervalTimer?.current?.pause();
    recordPlayTimeIntervalTimer.current = undefined;
    sendPlayTimeIntervalTimer?.current?.pause();
    sendPlayTimeIntervalTimer.current = undefined;
    clearTimeout(lastPlayedNoteTimer.current);
    lastPlayedNoteTimer.current = undefined;
    scheduler2?.pauseTicks();
    if (localPlaySessionId) {
      dispatch(
        eventActions.levelPauseEventAction(
          data.levelData[data.levelSelect].level_number,
          localPlaySessionId,
        ),
      );
    }
  }, [
    scheduler2,
    data.levelData,
    data.levelSelect,
    dispatch,
    localPlaySessionId,
    restoreSavedTempo,
  ]);

  // Capture the scheduler generation at the time this callback is created.
  // If reset() bumps the generation before Phaser fires StartedPlaying,
  // the stale onStart will detect the mismatch and bail out.
  const onStartGeneration = schedulerGenerationRef.current;
  const onStart = React.useCallback(
    async (args: StartPlayingArgs | void) => {
      // Guard: if reset() has bumped the generation since this closure was
      // created, this is a stale onStart from before the reset. Bail out —
      // the new onStart (with the current scheduler) will be triggered when
      // the lessonPlaying effect re-runs after the state update propagates.
      if (onStartGeneration !== schedulerGenerationRef.current) {
        console.log(
          `[EXERCISE-DBG] [MainAppPhaser.onStart] STALE — onStartGeneration=${onStartGeneration} schedulerGeneration=${schedulerGenerationRef.current}`,
        );
        return;
      }
      console.log(
        `[EXERCISE-DBG] [MainAppPhaser.onStart] startedRef=${startedRef.current} lastPlayedMeasure=${lastPlayedMeasureRef.current} hasArgs=${!!args} scheduler2=${!!scheduler2}`,
      );
      logger.debug(
        `[MUS119] onStart CALLED — startedRef=${startedRef.current} lastPlayedMeasure=${lastPlayedMeasureRef.current} hasArgs=${!!args}`,
      );
      await scheduler2?.init({
        tier: currentUserLevelData?.current_tier,
        levelNumber: currentUserLevelData?.level?.level_number,
        isEligible: false,
        phrasesTilNextTier: MIN_NUM_PHRASES,
        tempo: tempoRef.current,
      });
      scheduler2?.runEventListeners();
      if (!startedRef.current) {
        // this has to be initialized after the page is loaded and the user has made an action on the screen
        startMidiStreamUpdateLoop();
        //startPhraseLoop();
        startAccuracyLoop();
        startChevronLoop();
        // startPhraseCompletedEventLoop()
        setStarted(true);
        if (localPlaySessionId) {
          dispatch(
            eventActions.levelPlayEventAction(
              data.levelData[data.levelSelect].level_number,
              localPlaySessionId,
            ),
          );
        }
      }
      if (!recordPlayTimeIntervalTimer?.current) {
        // set last measted time ref on play in order to zero out the time spent during pause.
        lastMeasuredTimeRef.current = new Date().getTime();
        recordPlayTimeIntervalTimer.current = new IntervalTimer(recordPlayTimeInterval, 1000);
        recordPlayTimeIntervalTimer?.current?.start();
      } else {
        // after refactoring to create a new interval function with a new start time after each pause, this really shouldn't run,
        // but I'm going to keep the code anyway just in case.
        recordPlayTimeIntervalTimer?.current?.resume();
      }
      if (!sendPlayTimeIntervalTimer?.current) {
        // set last measted time ref on play in order to zero out the time spent during pause.
        sendPlayTimeIntervalTimer.current = new IntervalTimer(sendPlayTimeInterval, 10000);
        sendPlayTimeIntervalTimer?.current?.start();
      } else {
        // after refactoring to create a new interval function with a new start time after each pause, this really shouldn't run,
        // but I'm going to keep the code anyway just in case.
        sendPlayTimeIntervalTimer?.current?.resume();
      }

      if (process.env.REACT_APP_CURSOR_TIMEOUT) {
        clearTimeout(lastPlayedNoteTimer.current);
        lastPlayedNoteTimer.current = setInterval(() => {
          dispatch(lessonActions.setLessonPlaying({ lessonPlaying: false }));
        }, 10000);
      }
      //await scheduler2?.unpauseTicks(tempo, 1, lastPlayedMeasureRef.current + 1, tickNoteType);
      if (args) {
        const { measureOffset, processEventsQueue } = args;
        const [queueHandlerCallback, context] = processEventsQueue;
        // Await unpauseTicks so the native scheduler finishes and TimeKeeper
        // is unpaused before processEventsQueue runs. Without this, the first
        // MIDI note is dropped because handleNoteOnEvent early-returns on isPaused().
        await scheduler2?.unpauseTicks(tempoRef.current, 1, measureOffset, tickNoteType, true);
        queueHandlerCallback.call(context);
      } else {
        logger.debug(
          `[MUS119] onStart unpauseTicks (no args) — lastPlayedMeasure=${
            lastPlayedMeasureRef.current
          } measureOffset=${Math.max(lastPlayedMeasureRef.current, 0)} tempo=${tempoRef.current}`,
        );
        scheduler2?.unpauseTicks(
          tempoRef.current,
          1,
          Math.max(lastPlayedMeasureRef.current, 0),
          tickNoteType,
          true,
        );
        //NotifyPhaser(SetCursor(lastPlayedMeasureRef.current));
      }

      // Safety net: correct the TimeKeeper BPM if unpauseTicks overwrote it
      // with a stale value (shouldn't happen now that we use tempoRef, but
      // guards against any residual mismatch).
      const latestTempo = tempoRef.current;
      if (timeKeeper.getBpm() !== latestTempo) {
        logger.debug('[MainAppPhaser] correcting TimeKeeper BPM after unpause', {
          staleBpm: timeKeeper.getBpm(),
          correctBpm: latestTempo,
        });
        timeKeeper.setBpm(latestTempo);
      }

      //NotifyPhaser(SetCursor(lastPlayedMeasureRef.current));
      //NotifyPhaser(StartExercise(tempo));
    },
    [scheduler2],
  );

  React.useEffect(() => {
    console.log(
      `[EXERCISE-DBG] [MainAppPhaser] lessonPlaying effect — lessonPlaying=${lessonPlaying}`,
    );
    if (lessonPlaying) {
      onStartRequest();
    } else {
      onStop();
    }
  }, [lessonPlaying, onStop]);

  React.useEffect(() => {
    const blurListener = () => {
      dispatch(lessonActions.setLessonPlaying({ lessonPlaying: false }));
    };
    window.addEventListener('blur', blurListener);
    return () => {
      window.removeEventListener('blur', blurListener);
    };
  }, [dispatch, timeKeeper]);

  // Sync tempo to timekeeper and Phaser when it changes
  React.useEffect(() => {
    timeKeeper.setBpm(tempo);
    NotifyPhaserEvents.ChangeTempo({ tempo });
  }, [tempo, timeKeeper]);

  // Spacebar play/pause handler — registered once with refs so it always
  // reads the latest lessonPlaying value. Previous implementation re-registered
  // on every lessonPlaying change, causing duplicate listeners during tier
  // transitions when the component unmounted/remounted.
  React.useEffect(() => {
    const listener = (e: KeyboardEvent) => {
      e.preventDefault();
      if (e.key == ' ' && phrasesTilNextTierRef.current !== 0) {
        dispatch(lessonActions.setLessonPlaying({ lessonPlaying: !lessonPlayingRef.current }));
      }
    };

    keyCallbackRef.current = listener;
    document.addEventListener('keyup', listener);
    return () => {
      document.removeEventListener('keyup', listener);
      keyCallbackRef.current = null;
    };
  }, [dispatch]);

  useEffect(() => {
    const update = ({ phrasesTillNextTier }: { phrasesTillNextTier: number }) => {
      dispatch(lessonActions.updatePhrasesTilNextTier(phrasesTillNextTier));
    };
    const updateChevronPulsing = ({ eligible }: { eligible: boolean }) => {
      logger.debug('PTNT: updating chevron pulsing to ', eligible);
      if (tempo >= minTempoForChevronFlash) {
        setAllowChevrons(eligible);
      } else {
        setAllowChevrons(false);
      }
    };
    PhaserToReactListeners.SetPhrasesTillNextTier(update);
    PhaserToReactListeners.SetPhraseEligible(updateChevronPulsing);
    return () => {
      RemoveListener('SetPhrasesTillNextTier');
      RemoveListener('SetPhraseEligible');
    };
  }, [dispatch, tempo, setAllowChevrons, localPlaySessionId, musicLoaded]);

  // Spacebar listener is now managed by the useEffect above with proper
  // cleanup. This function is kept as a no-op for call-site compatibility.
  const initSpacebarListener = React.useCallback(() => {
    // No-op: spacebar listener is managed by the useEffect with refs
  }, []);

  // When do I set this? 4 bars...
  // setAllowChevrons()

  const resetLoops = React.useCallback(() => {
    scheduler2.clearTimeoutFn('chevronLoopStartTimeout');
    scheduler2.clearTimeoutFn('phraseLoopTimeout');
    scheduler2.clearIntervalFn('chevronLoop');
    scheduler2.clearIntervalFn('accuracyLoop');
    scheduler2.clearIntervalFn('phraseLoop');
    scheduler2.clearIntervalFn('updateMidiStream');
    setStarted(false);
    // startChevronLoop()
  }, [scheduler2]);

  const reset = React.useCallback(async () => {
    if (currentUserLevelData?.current_tier && lesson.currentUserLevelData?.play_session?.id) {
      initSpacebarListener();
      // dispatch(lessonActions.updatePhrasesTilNextTier(MIN_NUM_PHRASES));
      // dispatch(lessonActions.updateCurrentULP({
      //   currentUserLevelProgress: {
      //     status: LevelStatus.active,
      //   },
      // }))
      const tiers = await getTiersForLevel();
      if (tiers.length) {
        dispatch(lessonActions.updateCurrentLevelTiers(tiers.length));
      }
      setMusicLoaded(false);
      setShowMusic(false);
      timeKeeper.resetTime();
      midiStream.reset();
      scheduler2.destroy();
      resetLoops();
      schedulerGenerationRef.current += 1;
      const newScheduler = new Scheduler2(timeKeeper);
      setScheduler2(newScheduler);
      newScheduler?.updateWorkerState({
        phrasesTilNextTier: phrasesTilNextTier,
        levelNumber: data.levelData[data.levelSelect].level_number,
        tier: currentTier,
        play_session_id: lesson.currentUserLevelData?.play_session?.id,
      });
      setMidiStream(midiStream);
      // resetScheduler()
      clearTimeout(lastPlayedNoteTimer?.current);
      lastPlayedNoteTimer.current = undefined;
      recordPlayTimeIntervalTimer.current?.pause();
      recordPlayTimeIntervalTimer.current?.clear();
      recordPlayTimeIntervalTimer.current = undefined;
      sendPlayTimeIntervalTimer.current?.pause();
      sendPlayTimeIntervalTimer.current?.clear();
      sendPlayTimeIntervalTimer.current = undefined;
      setAllowChevrons(false);
      setAccuracy(100);
      dispatch(lessonActions.updatePhrasesTilNextTier(MIN_NUM_PHRASES));
      NotifyPhaserEvents.ResetChevrons();
      lastPlayedMeasureRef.current = -1;
      servedPhraseHashesRef.current = new Set();
      timeSigDispatchedRef.current = false;
      accumulatedTimeRef.current = 0;

      setStarted(false);
      clearListeners();
      addListener(listener.current);
      // Phrases are pulled on demand by the PhraseManager (FetchPhrase ->
      // fetchPhrase -> PhraseReady), so there's no buffer to pre-fill here.
      // Show the game immediately; the time signature for the UI is dispatched
      // from the first fetched phrase in fetchPhrase.
      setMusicLoaded(true);
      setShowMusic(true);
      setInitialized(true);
    }
  }, [
    setAllowChevrons,
    setAccuracy,
    dispatch,
    midiStream,
    scheduler2,
    resetLoops,
    lesson.currentUserLevelData?.play_session?.id,
    currentUserLevelData?.current_tier,
    currentUserLevelData?.level?.level_number,
    data.levelData,
    data.levelSelect,
    localPlaySessionId,
    mobile,
  ]);

  const sightReadingTransformKey = `${effectiveSightReadingTransposeSemitones}:${effectiveSightReadingModeConversion}`;
  const previousSightReadingTransformKeyRef = React.useRef(sightReadingTransformKey);

  const handleSightReadingTransposeChange = React.useCallback(
    (nextSemitones: number) => {
      if (nextSemitones === sightReadingTransposeSemitones) {
        return;
      }
      onSightReadingTransposeChange?.(nextSemitones);
    },
    [onSightReadingTransposeChange, sightReadingTransposeSemitones],
  );

  const handleSightReadingModeConversionChange = React.useCallback(
    (nextMode: ParallelModeConversion) => {
      if (nextMode === sightReadingModeConversion) {
        return;
      }
      onSightReadingModeConversionChange?.(nextMode);
    },
    [onSightReadingModeConversionChange, sightReadingModeConversion],
  );

  // Live transpose / mode change: pause so the clock re-syncs on the next play,
  // then let the PhraseManager re-transpose the on-screen phrases in place
  // (no exercise reset / remount).
  React.useEffect(() => {
    if (previousSightReadingTransformKeyRef.current === sightReadingTransformKey) {
      return;
    }
    previousSightReadingTransformKeyRef.current = sightReadingTransformKey;

    if (!localPlaySessionId) {
      return;
    }

    dispatch(lessonActions.setLessonPlaying({ lessonPlaying: false }));
    NotifyPhaserEvents.SetSightReadingTranspose({
      semitones: effectiveSightReadingTransposeSemitones,
      modeConversion: effectiveSightReadingModeConversion,
    });
  }, [
    dispatch,
    localPlaySessionId,
    sightReadingTransformKey,
    effectiveSightReadingTransposeSemitones,
    effectiveSightReadingModeConversion,
  ]);

  /* 
  Note: Play session id changing is how the lesson page is re-rendered. This can happen when a tier changes or a level changes.
        There can be a lot of tricky edge cases and bugs in this, so if you're messing with it, try all of the following:
  Senarios:
  1. First time visiting level
  2. Change tier:
    - This can happen either from advancing or manually changing the tier with the navigation buttons
    - change of tier is done via new play session as described in note above, so just watch for change of the play session id.
  3. Replay tier
  4. Nav to new level after playing a level already
  5. refresh on level
  */

  React.useEffect(() => {
    // using the "local" play session ID here ensures that a new ID is created whenever a level is entered.
    if (localPlaySessionId) {
      reset();
      setMusicLoaded(false);
      setShowMusic(false);
    }
  }, [localPlaySessionId]);

  React.useEffect(() => {
    if (lesson.currentUserLevelData?.play_session?.id !== localPlaySessionId) {
      setInitialized(false);
      setLocalPlaySessionId(lesson.currentUserLevelData?.play_session?.id);
      if (
        lesson?.currentUserLevelData?.level.level_number &&
        lesson.currentUserLevelData?.play_session?.id &&
        lesson?.currentUserLevelData?.current_tier
      ) {
        dispatch(
          eventActions.tierStartedEventAction(
            lesson?.currentUserLevelData?.level.level_number,
            lesson?.currentUserLevelData?.current_tier,
            lesson.currentUserLevelData?.play_session?.id,
          ),
        );
        if (lesson?.currentUserLevelData?.current_tier === 1) {
          dispatch(
            eventActions.levelStartedEventAction(
              lesson?.currentUserLevelData?.level.level_number,
              lesson.currentUserLevelData?.play_session?.id,
            ),
          );
        }
      }
    }
  }, [
    lesson.currentUserLevelData?.play_session?.id,
    dispatch,
    lesson.currentUserLevelData?.current_tier,
    lesson.currentUserLevelData?.level?.level_number,
    localPlaySessionId,
  ]);

  // entrypoint for sight reading trainer initialization. This is where the new session is created on load.
  React.useEffect(() => {
    if (authInitialized && data.userData && data.levelData?.[levelSelect]?.level_number) {
      const uld = data.userLevelData.find((ulp) => ulp.level?.level_number === data.levelSelect);
      // Calculate the appropriate tier to start on:
      // - If level is complete (level_completed_at exists), use highest_tier_complete (replay the last tier)
      // - If level is in progress, use highest_tier_complete + 1 (continue to next tier)
      // - Default to 1 if no progress exists
      // Note: The saga will validate and clamp this to the actual max tiers for the level
      let tierNumber = 1;
      if (uld) {
        const highestComplete = uld.highest_tier_complete ?? 0;
        if (uld.level_completed_at && highestComplete >= 1) {
          tierNumber = highestComplete;
        } else if (highestComplete >= 1) {
          tierNumber = highestComplete + 1;
        } else {
          tierNumber = 1;
        }
      }

      dispatch(
        lessonActions.createLevelSession({
          level_number: data?.levelData[levelSelect].level_number,
          tier_number: tierNumber,
          error_recognition_mode: ERROR_RECOGNITION_MODE.MIDI,
        }),
      );
    }
  }, [authInitialized]);

  React.useCallback(() => {}, []);

  // React.useEffect(()=> {
  //   Logger.log("setting play session id to undefined")
  //   dispatch(eventActions.setPlaySessionId(undefined))
  // }, [data.currentUserLevelData?.current_tier])

  const onStartRequest = React.useCallback(() => {
    console.log(`[EXERCISE-DBG] [MainAppPhaser.onStartRequest] tempo=${tempo}`);
    NotifyPhaserEvents.StartExercise({ tempo });
    //onStart();
  }, [tempo]);

  React.useEffect(() => {
    logger.debug('scheduler', scheduler2);
  }, [scheduler2.tickIntervalFn]);

  /*const startPlaying = React.useCallback(
    (args?: StartPlayingArgs) => {
      onStart(args);
    },
    [onStart]
  );*/

  React.useEffect(() => {
    const exercisePaused = ({ lastPlayedMeasure }: { lastPlayedMeasure?: number }) => {
      lastPlayedMeasureRef.current = lastPlayedMeasure || lastPlayedMeasureRef.current;
    };
    PhaserToReactListeners.ExercisePaused(exercisePaused);
    PhaserToReactListeners.StartedPlaying(onStart);
    return () => {
      RemoveListener('StartedPlaying');
      RemoveListener('ExercisePaused');
    };
  }, [onStart]);

  React.useEffect(() => {
    // check for lesson playing because the app tour sets phrasesTilNextTier to 0 during the tour
    // check for !freePlay because Free Play mode should not count toward tier/level completion
    if (
      phrasesTilNextTier === 0 &&
      currentUserLevelData?.play_session?.id &&
      lessonPlaying &&
      !freePlay
    ) {
      logger.debug('calling tier wrap up and completing level');
      logger.debug('previousTier', previousTier);
      logger.debug('currentUserLevelData.current_tier', currentUserLevelData?.current_tier);
      logger.debug('currentUserLevelData.play_session_id', currentUserLevelData?.play_session?.id);
      logger.info('sending phrase event on end');

      const playSessionId = currentUserLevelData.play_session.id;
      const levelNumber = data.levelData[levelSelect].level_number;

      setStarted(false);
      onStop();

      // Delay to allow held MIDI notes to settle before generating phrase data.
      // All dispatches run in the same microtask so saga processes them in order:
      // phrase event → tier/level events → flush (with callback that triggers wrap-up).
      setTimeout(() => {
        dispatchPhraseEvent(levelNumber, currentTier, playSessionId, 0, true);
        dispatch(eventActions.tierCompletedEventAction(levelNumber, currentTier, playSessionId));
        if (currentTier >= currentLevelTiers) {
          dispatch(eventActions.levelCompletedEventAction(levelNumber, playSessionId));
        }
        dispatch(eventActions.flushEventsAndWrapUp());
      }, 200);
      const now = new Date();
      const ulpPatch: Partial<UserLevelData> = {};
      if (
        !currentUserLevelData?.highest_tier_complete ||
        currentTier > currentUserLevelData?.highest_tier_complete
      ) {
        ulpPatch['highest_tier_complete'] = currentTier;
        ulpPatch['highest_tier_completed_at'] = now.toISOString();
      }
      if (!currentUserLevelData?.level_completed_at && currentTier >= currentLevelTiers) {
        ulpPatch['level_completed_at'] = now.toISOString();
      }
      dispatch(lessonActions.setCurrentCompletedAt(now));

      if (currentTier >= currentLevelTiers) {
        // This is bugged somehow? All my levels have a date for level_completed_at. but still active.. (or maybe that's intentional if playing again; changed highet level complete to be set based on level_completed_at)
        ulpPatch['status'] = LevelStatus.complete;
      }
      if (Object.keys(ulpPatch).length) {
        dispatch(
          lessonActions.updateCurrentULP({
            currentUserLevelProgress: ulpPatch,
          }),
        );
      }
      sendPlayTimeInterval();
      accumulatedTimeRef.current = 0; // should start over between tier/level sessions
      midiStream.reset();
      return () => {
        setInitialized(false);
      };
    }
  }, [currentUserLevelData?.play_session?.id, phrasesTilNextTier, freePlay, dispatch, onStop]);

  useComponentWillUnmount(() => {
    removeListener(listener.current);
    if (keyCallbackRef?.current) {
      document.removeEventListener('keyup', keyCallbackRef?.current);
    }
    if (process.env.REACT_APP_CURSOR_TIMEOUT) {
      clearTimeout(lastPlayedNoteTimer.current);
    }
    setInitialized(false);
    onStop();
    dispatch(lessonActions.setLessonPlaying({ lessonPlaying: false }));
    midiStream.reset();
    scheduler2?.reset();
    scheduler2?.cleatPauseUnpauseCallbacks();
    // midiAccess?.inputs.map(input => input.disconnec
    // terminate(scheduler2)
    // scheduler = undefined;
    // set play session id to null on exit in order to clear state for next run.
    // This only ever matters in the edge case where you go back to the roadmap and immediately
    // click into the same level
    // For some reason there's a bug in React where the previous "localPlaySessionId" is still around
    // when the level is re-rendered, even though it shouldn't be
    dispatch(
      lessonActions.updateCurrentULP({
        currentUserLevelProgress: { play_session: { id: null } },
      }),
    );
    // prevent stale data from levels with more tiers causing 404 on load of level with fewer
    // but we should really grab the tiers before the leve loads
    dispatch(lessonActions.updateCurrentLevelTiers(1));
    dispatch(lessonActions.setCurrentCompletedAt(null));
    // return () => {setInitialized(false)}
  });

  const parentRef = React.useRef<HTMLElement | undefined>(undefined);

  const togglePlayPause = React.useCallback(() => {
    dispatch(lessonActions.setLessonPlaying({ lessonPlaying: !lessonPlaying }));
  }, [lessonPlaying, dispatch]);

  React.useLayoutEffect(() => {
    if (parentRef) {
      const rect = parentRef.current?.getBoundingClientRect();
      if (rect && rect.height !== 0 /*&& rect.width > 960 && rect.height > 640*/) {
        setDimens({ x: rect.width, y: rect.height });
        logger.debug('[MainAppPhaser] dimensions set to ', {
          x: rect.width,
          y: rect.height,
        });
      }
    }
  }, [musicLoaded]);

  const showSpinner = !musicLoaded || !showMusic;

  return (
    <Box sx={{ height: '100%', width: '100%' }} ref={parentRef}>
      {showTierComplete && (
        <Box
          sx={{
            height: '110%', // doesn't go all the way up for some reason
            width: '100%',
            visibility: lesson.phrasesTilNextTier === 0 ? 'unset' : 'hidden',
            backgroundColor: '#414753',
            opacity: '70%',
            position: 'absolute',
            zIndex: '1500',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CustomCircularProgress sx={{}} />
        </Box>
      )}
      <div
        className="App"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          width: '100%',
          background: scorePalette.scoreBackground,
          height: '100%',
          //overflow: 'hidden',
          position: 'relative',
        }}
      >
        {/* commenting out tosts for now while we figure out the actual implementation */}
        {/* eslint-disable-next-line no-constant-binary-expression -- feedback toast intentionally disabled */}
        <Box
          sx={{
            position: 'absolute',
            //left: '50%',
            //transform: 'translateX(-50%)',
            //bottom: 'calc(16px + env(safe-area-inset-bottom, 0px))',
            // Mobile lifts the toasts above the bottom toolbar so they don't
            // get clipped by the viewport edge / safe-area inset; desktop
            // keeps the original below-the-container behavior.
            bottom: mobile ? 'calc(80px + env(safe-area-inset-bottom, 0px))' : '-40px',
            zIndex: 2000,
            display: 'flex',
            flexDirection: 'row',
            gap: '10px',
            width: '100%',
            height: '50px',
            pointerEvents: 'none',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {feedbackToastText && <FeedbackToast text={feedbackToastText} />}
          {/*{<FeedbackToast text="Hello, world!" />}*/}
          {tempoToast && (
            <TempoToast text={tempoToast[0] ?? ''} visible={tempoToastVisible} mobile={mobile} />
          )}
        </Box>
        {musicLoaded && dimens && (
          <>
            {lessonZoomEnabled && !mobile && (
              <ZoomSlider zoomLevel={zoomLevel} setZoomLevel={setZoomLevel} />
            )}
            {/*<Button
              sx={{ position: 'absolute', top: '10px', right: '200px', zIndex: 2000 }}
              onClick={() => setTempoToast({ text: 'this is a test', visible: true })}
            >
              Show Tempo Toast
            </Button>
            <Button
              sx={{ position: 'absolute', top: '10px', right: '300px', zIndex: 2000 }}
              onClick={() => setTempoToast({ text: 'this is a test', visible: false })}
            >
              Hide Tempo Toast
            </Button>*/}
            {settingsShown && (
              <SettingsPanel
                onClose={onCloseSettings}
                setShowDebugTierSummary={setShowDebugTierSummary}
                showDebugTierSummary={showDebugTierSummary}
                setShowDebugRepertoireUnlocked={setShowDebugRepertoireUnlocked}
                showDebugRepertoireUnlocked={showDebugRepertoireUnlocked}
                open={true}
                setZoomLevel={setZoomLevel}
                setCursorVisible={setCursorIsVisible}
                setPianoSound={(sound: boolean) =>
                  dispatch(appActions.setAudioOn({ audioOn: sound }))
                }
                setMetronomeSound={(sound: boolean) => {
                  dispatch(appActions.setRepMetronomeSound(sound));
                  scheduler2.changeMetronomeAudio(sound);
                }}
                pianoSound={userData?.audio_on ?? true}
                cursorVisible={cursorIsVisible}
                zoomLevel={zoomLevel}
                metronomeSound={userData?.rep_metronome_sound ?? true}
                showTransposeControls={transposeSightReadingTrainerEnabled}
                transposeSemitones={sightReadingTransposeSemitones}
                onTransposeChange={handleSightReadingTransposeChange}
                modeConversion={sightReadingModeConversion}
                onModeConversionChange={handleSightReadingModeConversionChange}
              ></SettingsPanel>
            )}
            <Game
              eventStream={midiStream}
              width={dimens.x}
              height={dimens.y}
              togglePlayPause={togglePlayPause}
              mobile={mobile}
              parentRef={parentRef}
              dispatch={dispatch}
              playButtonOverlap={playButtonOverlap}
              zoomLevel={zoomLevel}
              goalTempo={goalTempo}
              ataEnabled={ataEnabled}
              playing={lessonPlaying}
              freePlayMode={freePlayMode}
              usingCustomGoalTempo={usingCustomGoalTempo}
              scoreTheme={scoreTheme}
              transposeSemitones={effectiveSightReadingTransposeSemitones}
              modeConversion={effectiveSightReadingModeConversion}
              cursorIsVisible={cursorIsVisible}
            />
          </>
        )}
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          {showSpinner && <CustomCircularProgress />}
        </Box>
      </div>
    </Box>
  );
}

const Game = ({
  eventStream,
  width,
  height,
  togglePlayPause,
  mobile,
  parentRef,
  dispatch: _dispatch,
  playButtonOverlap,
  zoomLevel,
  goalTempo,
  ataEnabled,
  playing,
  freePlayMode,
  usingCustomGoalTempo,
  scoreTheme,
  transposeSemitones,
  modeConversion,
  cursorIsVisible,
}: {
  eventStream: EventStreamPhaser2 | OSMDEventStream;
  width: number;
  height: number;
  togglePlayPause: () => void;
  mobile: boolean;
  parentRef: React.RefObject<HTMLElement | undefined>;
  dispatch: AppDispatch;
  playButtonOverlap?: number;
  zoomLevel: number;
  goalTempo: number;
  ataEnabled: boolean;
  playing: boolean;
  freePlayMode: boolean;
  usingCustomGoalTempo: boolean;
  scoreTheme: ScoreTheme;
  transposeSemitones: number;
  modeConversion: ParallelModeConversion;
  cursorIsVisible: boolean;
}) => {
  const [phaserLoaded, setPhaserLoaded] = React.useState(false);
  const scorePalette = getScoreThemePalette(scoreTheme);
  const phaserRef = React.useRef<IRefPhaserGame | null>(null);

  // Tap-to-play/pause is for touch devices only (desktop uses the play/pause
  // button). Gate on touch capability, NOT the `mobile` small-screen flag: an
  // iPad in landscape is wide enough that `mobile` is false, yet it's still a
  // touch device and should toggle on tap. Pausing is a single tap (responsive,
  // like tapping to stop a video), but starting playback requires a quick
  // double-tap so a single stray tap doesn't start playback unexpectedly.
  const touchDevice = React.useMemo(() => isTouchDevice(), []);
  const lastScoreTapRef = React.useRef(0);
  const DOUBLE_TAP_MS = 300;
  const handleScoreTap = React.useCallback(() => {
    // Single tap pauses immediately.
    if (playing) {
      lastScoreTapRef.current = 0; // drop any pending first-tap
      togglePlayPause();
      return;
    }
    // Paused/stopped: require a quick double-tap to start.
    const now = Date.now();
    if (now - lastScoreTapRef.current > DOUBLE_TAP_MS) {
      lastScoreTapRef.current = now; // first tap; wait for a second
      return;
    }
    lastScoreTapRef.current = 0; // consume the pair
    togglePlayPause();
  }, [playing, togglePlayPause]);
  // Read via refs so the initial scene config picks up the current transpose
  // without making `load` re-run (live transpose flows through the event, not a
  // scene restart).
  const transposeSemitonesRef = React.useRef(transposeSemitones);
  transposeSemitonesRef.current = transposeSemitones;
  const modeConversionRef = React.useRef(modeConversion);
  modeConversionRef.current = modeConversion;
  // Keep the latest cursor-visibility pref in a ref so the scene init config
  // (built inside the memoized load callback) always seeds the correct value.
  const cursorIsVisibleRef = React.useRef(cursorIsVisible);
  cursorIsVisibleRef.current = cursorIsVisible;
  const load = useCallback(() => {
    const scene = phaserRef.current?.scene;
    const game = phaserRef.current?.game;
    const sceneIsActive = scene?.sys?.isActive() || scene?.sys?.isPaused();
    const effectiveGoalTempo = freePlayMode ? (usingCustomGoalTempo ? goalTempo : 300) : 72;
    const config = {
      eventStream,
      mobile,
      width,
      height,
      zoomLevel,
      goalTempo: effectiveGoalTempo,
      ataEnabled,
      freePlayMode,
      scoreTheme,
      transposeSemitones: transposeSemitonesRef.current,
      modeConversion: modeConversionRef.current,
      cursorVisible: cursorIsVisibleRef.current,
    };

    if (sceneIsActive && scene) {
      scene.scene.start('SightReadingPhaser', config);
    } else if (game) {
      game.scene.start('SightReadingPhaser', config);
    } else {
      return;
    }

    setPhaserLoaded(true);
  }, [
    phaserRef,
    eventStream,
    goalTempo,
    freePlayMode,
    usingCustomGoalTempo,
    ataEnabled,
    scoreTheme,
  ]);
  const dummyRef = React.useRef<HTMLDivElement>(null);
  React.useEffect(() => {
    const cb = (arg: { x: number; y: number }) => {
      if (dummyRef.current) {
        dummyRef.current.style.top = arg.y + 'px';
        dummyRef.current.style.left = arg.x + 'px';
      }
    };
    PhaserToReactListeners.SetNotePosDummy(cb);
    return () => {
      RemoveListener('SetNotePosDummy');
    };
  }, []);
  useEffect(() => {
    const handleResize = debounce(() => {
      // Don't resize when document is hidden (tab not visible)
      if (document.hidden) return;

      const width = parentRef.current?.clientWidth;
      const height = parentRef.current?.clientHeight;

      // Guard against invalid dimensions (can happen when window is minimized or off-screen)
      if (!width || !height || width < 100 || height < 100) return;

      NotifyPhaserEvents.ResizeWindow({
        width,
        height,
        playButtonOverlap,
      });
      NotifyPhaserEvents.SetCursor({ measure: 0 });
    }, 100);

    // Use ResizeObserver to detect container size changes (works for fullscreen too)
    const resizeObserver = new ResizeObserver(() => {
      handleResize();
    });

    if (parentRef.current) {
      resizeObserver.observe(parentRef.current);
    }

    // Also listen for window resize as fallback
    window.addEventListener('resize', handleResize);

    // Trigger resize when visibility changes (coming back from another tab/window)
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        // Small delay to let the browser update dimensions
        setTimeout(handleResize, 50);
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('resize', handleResize);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      handleResize.cancel();
    };
  }, [playButtonOverlap]);

  // Trigger resize when overlap changes
  useEffect(() => {
    const width = parentRef.current?.clientWidth;
    const height = parentRef.current?.clientHeight;
    if (width && height) {
      NotifyPhaserEvents.ResizeWindow({
        width: Math.max(width, 960),
        height,
        playButtonOverlap,
      });
    }
  }, [playButtonOverlap]);
  useEffect(() => {
    // When the singleton game is reused, PhaserReady won't fire again.
    // Load the scene directly.
    if (phaserRef.current?.wasReused) {
      load();
    }
    PhaserToReactListeners.PhaserReady(load);
    return () => {
      RemoveListener('PhaserReady');
    };
  }, [load]);

  // Scene cleanup on unmount
  useEffect(() => {
    return () => {
      NotifyPhaserEvents.UnloadExercise();
    };
  }, []);

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        backgroundColor: scorePalette.scoreBackground,
        opacity: phaserLoaded ? 1 : 0,
        transition: 'opacity 0.3s ease-in-out, transform 1s ease-in-out',
        position: 'relative',
        transform: playing ? 'translateY(0px)' : mobile ? 'translateY(15px)' : 'translateY(0px)',
        // Disable native double-tap-to-zoom (and the legacy 300ms click delay) so a
        // quick double-tap fires two clicks instead of the second being swallowed
        // by the zoom gesture. Required for handleScoreTap's double-tap-to-play on iPad.
        touchAction: touchDevice ? 'manipulation' : undefined,
      }}
      onClick={touchDevice ? handleScoreTap : undefined}
    >
      <div
        ref={dummyRef}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '10px',
          height: '10px',
          //backgroundColor: 'red',
        }}
        id="note-pos-dummy"
      ></div>
      <PhaserGame
        width={width}
        height={height}
        ref={phaserRef}
        scaling={Phaser.Scale.NONE}
        crisp={true}
        playButtonOverlap={playButtonOverlap}
      />
    </div>
  );
};

const TempoToast = ({
  text,
  visible,
  mobile,
}: {
  text: string;
  visible: boolean;
  mobile: boolean;
}) => {
  // Fixed to the viewport so short mobile layouts / overflow on ancestors cannot clip ATA toasts.
  const bottomInset = 'calc(16px + env(safe-area-inset-bottom, 0px))';
  const stylesVisible = {
    bottom: bottomInset,
    transition: 'bottom 0.95s cubic-bezier(0.0, 0, 0.2, 1)',
    opacity: 1,
  };
  const stylesHidden = {
    bottom: '-200px',
    transition: 'opacity 2s linear, bottom 0s linear 2s',
    opacity: 0,
  };
  return (
    <Box
      sx={{
        ...(visible ? stylesVisible : stylesHidden),
        //position: 'fixed',
        //left: '50%',
        //transform: 'translateX(-50%)',
        backgroundColor: '#414753',
        color: 'white',
        fontSize: mobile ? '14px' : '24px',
        padding: mobile ? '12px 20px' : '16px 64px',
        borderRadius: '5px',
        zIndex: 2000,
        maxWidth: 'calc(100vw - 24px)',
        boxSizing: 'border-box',
        textAlign: 'center',
      }}
    >
      <Typography variant="h6" sx={{ fontSize: 'inherit', lineHeight: 1.3 }}>
        {text}
      </Typography>
    </Box>
  );
};

export default MainAppPhaser;
